import HttpClient from '@/common/boot/HttpClient'

const listarCampos = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/formularios/ctrl-campos/paginados`, { params: payload }).then(response => {
    commit('INSERIR_LISTA_CAMPOS', response.data.data)
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const listarCamposSemPaginacao = async ({ commit }, payload) => {
  commit('BUSCANDO', true);

  return await HttpClient.get(`/formularios/ctrl-campos`, { params: payload }).then(response => {
    commit('INSERIR_LISTA_CAMPOS', response.data)
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const salvarCampo = ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true);

  return HttpClient.post(`/formularios/ctrl-campos/salvar-campo-opcoes`, payload).then(response => {
    dispatch('listarCampos')
    return response
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const atualizarCampo = ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true);

  return HttpClient.put(`/formularios/ctrl-campos/${payload.id}`, payload).then(response => {
    dispatch('listarCampos')
    return response
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const deletarCampo = ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true);

  return HttpClient.delete(`/formularios/ctrl-campos/${payload.id}`).then(() => {
    dispatch('listarCampos')
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}

const restaurarCampo = ({ commit, dispatch}, payload) => {
  commit('BUSCANDO', true);

  return HttpClient.post(`/formularios/ctrl-campos/${payload.id}/restaurar`).then(() => {
    dispatch('listarCampos')
  })
  .finally( () => {
    commit('BUSCANDO', false);
  })
}


export {
  listarCampos,
  salvarCampo,
  atualizarCampo,
  deletarCampo,
  restaurarCampo,
  listarCamposSemPaginacao
}